<template>
  <div class="documentsPublic">
    <loading-overlay v-if="loading"></loading-overlay>
    <div class="select">
      <el-input
        v-model="sname"
        class="search"
        placeholder="请输入查找的文件名称"
        prefix-icon="el-icon-search"
        clearable
        @clear="search"
      ></el-input>
      <el-button
        type="warning"
        @click="search"
        style="margin-left: 10px; border-radius: 16px"
        >搜索</el-button
      >
    </div>
    <div class="table">
      <el-table
        ref="multipleTable"
        :data="tableData"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        max-height="650"
      >
        <el-table-column prop="name" label="文件名">
          <template slot-scope="scope">
            {{ scope.row.name }}
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="success"
              size="small"
              plain
              style="border-radius: 8px"
              @click="down(scope.row)"
              >导出</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import PizZip from 'pizzip'
import docxtemplater from 'docxtemplater'
import JSZipUtils from 'jszip-utils'
import { saveAs } from 'file-saver'
const fileTypeMap = {
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  png: 'image/png',
  gif: 'image/gif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  txt: 'text/plain'
}
export default {
  name: 'documentsPublic',
  data() {
    return {
      wordTemp: [
        {
          name: '委托协议（辩护）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '为犯罪嫌疑人提供帮助的委托协议', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '授权委托书（侦查）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '授权委托书（检、审）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '会见专用介绍信（嫌疑人 被告人）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '取保候审申请书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '刑事案件代理委托协议（诉讼代理人）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '授权委托书（刑事附带民事）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '授权委托书（诉讼代表人）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '调查取证申请书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '延期审理申请书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '解除强制措施申请书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },

        {
          name: '提请收集、调取证据申请书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '通知证人出庭申请书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '申请取保候审保证书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '会见在押犯罪嫌疑人申请书（涉及国密）', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },

        {
          name: '重新鉴定、勘验申请书', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },

        {
          name: '授权委托书(单位)', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '授权委托书(个人)', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '执行授权委托书(单位)', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '执行授权委托书(个人)', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        },
        {
          name: '新天伦律师事务所用印审批', // 模板名
          type: 1 // 类型(1:导出，2:打印)
        }
      ],
      tableData: [],
      sname: null,
      loading: false
    }
  },

  methods: {
    // 搜索
    search() {
      if (this.sname == null || this.sname == '') {
        this.tableData = this.wordTemp
      } else {
        this.tableData = []
        this.wordTemp.forEach((v) => {
          if (v.name.includes(this.sname)) {
            this.tableData.push(v)
          }
        })
      }
    },

    // 导出
    down(row) {
      let _this = this
      _this.loading = true
      // 导出
      //这里要引入处理图片的插件，下载docxtemplater后，引入的就在其中了
      var ImageModule = require('docxtemplater-image-module-free')
      var fs = require('fs')
      const expressions = require('angular-expressions')

      // 读取并获得模板文件的二进制内容，放在项目中即可（wordTemplate.docx是public文件下的word模版）
      JSZipUtils.getBinaryContent(
        row.name + '.docx',
        function (error, content) {
          if (error) {
            throw error
          }

          expressions.filters.size = function (input, width, height) {
            return {
              data: input,
              size: [width, height]
            }
          }
          function angularParser(tag) {
            const expr = expressions.compile(tag.replace(/’/g, "'"))
            return {
              get(scope) {
                return expr(scope)
              }
            }
          }

          // 图片处理
          let opts = {}
          opts = { centered: false }
          opts.getImage = (chartId) => {
            return _this.base64DataURLToArrayBuffer(chartId)
          }
          opts.getSize = function (img, tagValue, tagName) {
            //自定义指定图像大小，此处可动态调试各别图片的大小
            if (tagName === 'chartImg1') return [249, 200]
            return [300, 200]
          }

          // 创建一个PizZip实例，内容为模板的内容
          let zip = new PizZip(content)
          // 创建并加载docxtemplater实例对象
          let doc = new docxtemplater()
          // 去除未定义值所显示的undefined
          doc.setOptions({
            nullGetter: function () {
              return ''
            }
          })
          doc.attachModule(new ImageModule(opts))
          doc.loadZip(zip)

          doc.setData({
            code: '',
            title: '',
            client: '',
            acceptUnit: '',
            cause: '',
            orgName: '',
            applicantName: '',
            uploadTime: '',
            reason: '',
            printYear: '',
            printMonth: '',
            printDay: '',
            leadLawyer: '',
            bclName: '',
            yuanGao: '',
            beiGao: '',
            diSanRen: '',
            agentOther: '',
            xl: '',
            bm: '',
            ec: '',
            seal1: '',
            seal2: '',
            seal3: '',
            seal4: '',
            seal5: '',
            seal6: '',
            seal7: '',
            seal_1: '',
            seal_2: '',
            seal_3: '',
            seal_4: '',
            seal_5: '',
            seal_6: '',
            seal_7: ''
          })

          try {
            // 用模板变量的值替换所有模板变量
            doc.render()
          } catch (error) {
            // 抛出异常
            let e = {
              message: error.message,
              name: error.name,
              stack: error.stack,
              properties: error.properties
            }
            _this.loading = false
            throw error
          }

          // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
          let out = doc.getZip().generate({
            type: 'blob',
            mimeType:
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          })
          // 将目标文件对象保存为目标类型的文件，并命名
          saveAs(out, row.name + '.docx')
        }
      )
      _this.loading = false
    }
  },

  created() {
    this.tableData = this.wordTemp
  }
}
</script>

<style lang="less" scoped>
.documentsPublic {
  height: 100%;
  width: 100%;

  .select {
    text-align: center;
  }

  // 查询
  .search {
    width: 40%;
    margin-bottom: 2%;
  }
}
</style>